import {
    SAVE_CONSIGNMENT_DETAILS,
    SAVE_CONSIGNMENT_DETAILS_SUCCESS,
    SAVE_CONSIGNMENT_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_SURGERY,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    saveConsignment: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    saveConsignmentLoading: false,
};

const createConsignmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CONSIGNMENT_DETAILS:
            return {
                ...state,
                saveConsignmentLoading: true,
            };
        case SAVE_CONSIGNMENT_DETAILS_SUCCESS:
            return {
                ...state,
                saveConsignment: {
                    data: action.data,
                    statusCode: '10011',
                },
                saveConsignmentLoading: false,
            };
        case SAVE_CONSIGNMENT_DETAILS_FAILURE:
            return {
                ...state,
                saveConsignment: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                saveConsignmentLoading: false,
            };
        case RESET_CREATE_UPDATE_SURGERY:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'createConsignmentKey',
        storage: storage,
    },
    createConsignmentReducer
);
